import { Pipe, PipeTransform } from '@angular/core';
import { OrderdirectPurchaseInvoice } from '../services/orderdirect-purchase-invoice/orderdirect-purchase-invoice.service';

@Pipe({
    name: 'orderdirectPurchaseInvoiceStatus',
    standalone: false,
})
export class OrderdirectPurchaseInvoiceStatusPipe implements PipeTransform {
    transform(invoice: OrderdirectPurchaseInvoice): 'new' | 'pending' | 'completed' | 'failed' {
        if (invoice.failed_at) {
            return 'failed';
        }

        if (invoice.execute_at && !invoice.afas_ornu) {
            return 'pending';
        }

        if (invoice.afas_ornu) {
            return 'completed';
        }

        return 'new';
    }
}
